<h2 mat-dialog-title>Add Tower Alert</h2>
<mat-dialog-content>Tower data exists.Press confirm to use the old data or press cancel to provide unique tower name.</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>
